export const CHAT_PANEL_WIDTH = 420;
